window.ptStepper = () => {
    return {
        _scrollPosition: 0,
        currentStep: "init",
        isResult: false,
        name: null,
        selection: [],
        colors: [],

        get validateName() {
            return this.name === null || this.name.match(/^ *$/) !== null;
        },

        init() {
            if (!this.$store.pt.completed && !this.$store.pt.skiped) {
                this.open();
            }
            this.$watch('currentStep', () => this._scrollToTop());
        },

        _scrollToTop() {
            this.$el.scrollTop = 0;
        },

        _calculateResult() {
            const countChecked = {};
            this.$el.querySelectorAll("[type=checkbox]:checked").forEach(el => {
                if (el.dataset.value in countChecked) {
                    countChecked[el.dataset.value] += 1;
                } else {
                    countChecked[el.dataset.value] = 1;
                }
            });
            if (!Object.keys(countChecked).length) {
                return;
            }

            const maxNumber = Object.entries(countChecked).reduce(
                (max, el) => (el[1] > max ? el[1] : max),
                Object.entries(countChecked)[0][1]
            );

            this.colors = Object.keys(countChecked).filter(key => countChecked[key] === maxNumber).slice(0, 3);
        },

        prevStep() {
            const previousStep = this.$el.querySelector(`[data-step="${this.currentStep}"]`).previousSibling;
            if (previousStep) {
                this.currentStep = previousStep.dataset.step;
            }
        },

        nextStep() {
            const nextStep = this.$el.querySelector(`[data-step="${this.currentStep}"]`).nextElementSibling;
            if (nextStep) {
                if (nextStep.dataset.step === "result") {
                    this._calculateResult();
                    this.isResult = true;
                }
                if (nextStep.dataset.step === "start") {
                    this.currentStep = "0";
                } else {
                    this.currentStep = nextStep.dataset.step;
                }
            }
        },

        restart() {
            this.currentStep = "0";
        },

        reset() {
            this.currentStep = "start";
            this.name = null;
            this.selection = [];
            this.colors = [];
        },

        finish() {
            this.$store.pt.data(this.name, this.colors, this.selection);
            this.close();
        },

        open() {
            if (this.$store.pt.isComplete()) {
                this.currentStep = "result";
                this.isResult = false;
                this.name = this.$store.pt.name;
                this.colors = this.$store.pt.colors;
                this.selection = this.$store.pt.selection;
            }
            else if (this.$store.pt.skiped) {
                this.currentStep = "start";
            }
            else {
                this.currentStep = "init";
            }

            this._scrollPosition = window.pageYOffset;
            document.body.classList.add("basicLightbox--enabled");
            document.body.style.top = `-${this._scrollPosition}px`
            this.$el.classList.add("basicLightbox--visible");
        },

        close() {
            document.body.classList.remove("basicLightbox--enabled");
            document.body.style.top = null;
            window.scrollTo({
                top: this._scrollPosition,
                behavior: "instant"
            });
            this.$el.classList.remove("basicLightbox--visible");
        },

        cancel() {
            this.$store.pt.skip();
            this.close();
        }
    };
};
